import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { CoreUiModule } from "../module";

import { DgaRegulatoryItemsContainer } from "./dga/dga-regulatory-items.container";
import { RegulatoryItemsContainer } from "./regulatory-items.container";
import { StandardRegulatoryItemsComponent } from "./standard/standard-regulatory-items.component";

const DIRECTIVES = [RegulatoryItemsContainer, DgaRegulatoryItemsContainer, StandardRegulatoryItemsComponent];

@NgModule({
	imports: [CommonModule, CoreUiModule, TranslateModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class RegulatoryItemsModule {}
